import React, { useContext, useRef, useState, useEffect } from "react";
import { AuthContext } from "../context/auth";
import { useForm } from "../util/hooks";
import axios from "axios";
import { Mensaje } from "../components/mensajes";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import { RecuperarInformacion } from "../../src/components/recuperacionInfo/recuperarInfo";
import { Dimmer } from "../components/spinner";

function Login(props) {
  const [loading, setLoading] = useState(false);

  const op = require("../../public/modulos/datos");

  const context = useContext(AuthContext);
  const [mostrar, setMostrar] = useState(false);
  const { onChange, onSubmit, values } = useForm(loginUserCallback, {
    username: "",
    password: "",
  });

  const [tipoInput, setTipoInput] = useState("password");
  const [iconeye, setIconEye] = useState("fas fa-eye");
  const txtUserName = useRef(null);
  const txtPassword = useRef(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const cerrarInformacion = () => {
    setMostrar(false);
  };
  const abrirInformacion = () => {
    setMostrar(true);
  };

  const cargarIpMac = () => {
    let endpoint = `${op.ipmac}/ipmac.php`;
    axios
      .get(endpoint)
      .then(function (response) {
        if (response.status === 200) {
          localStorage.setItem("ip", JSON.stringify(response.data.ip));
          localStorage.setItem("mac", JSON.stringify(response.data.mac));
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const sinIgn = () => {
    let endpoint = op.conexion + "/api/auth/signin";

    var login = values.username;
    var passwd = values.password;

    axios
      .post(endpoint, {
        login: login,
        passwd: passwd,
      })
      .then(function (response) {
        if (response.status === 200) {
          context.login(response.data.token);
          if (response.data.token === null) {
            props.history.push("/");
          } else {
            console.log(response.data.idagente);
            localStorage.setItem(
              "idusuario",
              JSON.stringify(response.data.idusuario)
            );
            localStorage.setItem(
              "numcaja",
              JSON.stringify(response.data.numcaja)
            );
            localStorage.setItem(
              "idagente",
              JSON.stringify(response.data.idagente)
            );
            localStorage.setItem("login", JSON.stringify(response.data.login));
            localStorage.setItem(
              "fechasistema",
              JSON.stringify(response.data.fechasistema)
            );
            localStorage.setItem(
              "anioactu",
              JSON.stringify(response.data.anioactu)
            );
            localStorage.setItem(
              "idorganizacion",
              JSON.stringify(response.data.idorganizacion)
            );
            localStorage.setItem(
              "permisos",
              JSON.stringify(response.data.permisos)
            );
            localStorage.setItem(
              "numcaja",
              JSON.stringify(response.data.numcaja)
            );

            localStorage.setItem("efiseleccionado", false);
            localStorage.setItem("idefiscal", JSON.stringify(""));
            localStorage.setItem("efiscaldes", JSON.stringify(""));
            localStorage.setItem("efiscalanio", JSON.stringify(""));
            localStorage.setItem("statuspresup", JSON.stringify(""));
            localStorage.setItem("statuspuc", JSON.stringify(""));
            localStorage.setItem("statuscat", JSON.stringify(""));
            localStorage.setItem("statusorg", JSON.stringify(""));

            localStorage.setItem(
              "acctimbresfis",
              JSON.stringify(response.data.acctimbresfis)
            );
            localStorage.setItem(
              "accconfigtimbres",
              JSON.stringify(response.data.accconfigtimbres)
            );
            localStorage.setItem(
              "accpdftimbres",
              JSON.stringify(response.data.accpdftimbres)
            );
            localStorage.setItem(
              "accopexpendios",
              JSON.stringify(response.data.accopexpendios)
            );
            localStorage.setItem(
              "accopentes",
              JSON.stringify(response.data.accopentes)
            );

            localStorage.setItem(
              "accimpproduccion",
              JSON.stringify(response.data.accimpproduccion)
            );
            localStorage.setItem(
              "accconfigproducc",
              JSON.stringify(response.data.accconfigproducc)
            );
            localStorage.setItem(
              "accpdfproducc",
              JSON.stringify(response.data.accpdfproducc)
            );
            localStorage.setItem(
              "accregproducc",
              JSON.stringify(response.data.accregproducc)
            );
            localStorage.setItem(
              "accclaseproducc",
              JSON.stringify(response.data.accclaseproducc)
            );

            localStorage.setItem(
              "accimpminas",
              JSON.stringify(response.data.accimpminas)
            );
            localStorage.setItem(
              "accconfigminas",
              JSON.stringify(response.data.accconfigminas)
            );
            localStorage.setItem(
              "accpdfminas",
              JSON.stringify(response.data.accpdfminas)
            );
            localStorage.setItem(
              "accregminas",
              JSON.stringify(response.data.accregminas)
            );
            localStorage.setItem(
              "accclaseminas",
              JSON.stringify(response.data.accclaseminas)
            );

            localStorage.setItem(
              "accimp1x500",
              JSON.stringify(response.data.accimp1x500)
            );
            localStorage.setItem(
              "accconfig1x500",
              JSON.stringify(response.data.accconfig1x500)
            );
            localStorage.setItem(
              "accpdf1x500",
              JSON.stringify(response.data.accpdf1x500)
            );
            localStorage.setItem(
              "accreg1x500",
              JSON.stringify(response.data.accreg1x500)
            );

            localStorage.setItem(
              "accfiscal",
              JSON.stringify(response.data.accfiscal)
            );
            localStorage.setItem(
              "accconfigfiscal",
              JSON.stringify(response.data.accconfigfiscal)
            );
            localStorage.setItem(
              "accpdffiscal",
              JSON.stringify(response.data.accpdffiscal)
            );
            localStorage.setItem(
              "accregfiscal",
              JSON.stringify(response.data.accregfiscal)
            );
            localStorage.setItem(
              "accclasemulta",
              JSON.stringify(response.data.accclasemulta)
            );
            localStorage.setItem(
              "accclasetasa",
              JSON.stringify(response.data.accclasetasa)
            );
            localStorage.setItem(
              "accasignatasa",
              JSON.stringify(response.data.accasignatasa)
            );
            localStorage.setItem(
              "accgestion",
              JSON.stringify(response.data.accgestion)
            );
            localStorage.setItem(
              "accconfiggestion",
              JSON.stringify(response.data.accconfiggestion)
            );
            localStorage.setItem(
              "accpdfgestion",
              JSON.stringify(response.data.accpdfgestion)
            );
            localStorage.setItem(
              "accbancos",
              JSON.stringify(response.data.accbancos)
            );
            localStorage.setItem(
              "acccuentas",
              JSON.stringify(response.data.acccuentas)
            );
            localStorage.setItem(
              "accpresupuesto",
              JSON.stringify(response.data.accpresupuesto)
            );
            localStorage.setItem(
              "accconfigpresu",
              JSON.stringify(response.data.accconfigpresu)
            );
            localStorage.setItem(
              "accpdfpresu",
              JSON.stringify(response.data.accpdfpresu)
            );
            localStorage.setItem(
              "accefiscal",
              JSON.stringify(response.data.accefiscal)
            );

            localStorage.setItem(
              "accfvmtimbres",
              JSON.stringify(response.data.accfvmtimbres)
            );
            localStorage.setItem(
              "accfvproducc",
              JSON.stringify(response.data.accfvproducc)
            );
            localStorage.setItem(
              "accfvminas",
              JSON.stringify(response.data.accfvminas)
            );
            localStorage.setItem(
              "accfv1x500",
              JSON.stringify(response.data.accfv1x500)
            );
            localStorage.setItem(
              "accfvfiscal",
              JSON.stringify(response.data.accfvfiscal)
            );

            localStorage.setItem(
              "accconfigene",
              JSON.stringify(response.data.accconfigene)
            );
            localStorage.setItem(
              "accpersonas",
              JSON.stringify(response.data.accpersonas)
            );
            localStorage.setItem(
              "accusertim",
              JSON.stringify(response.data.accusertim)
            );
            localStorage.setItem("accuc", JSON.stringify(response.data.accuc));
            localStorage.setItem(
              "accute",
              JSON.stringify(response.data.accute)
            );
            localStorage.setItem(
              "accporcenute",
              JSON.stringify(response.data.accporcenute)
            );
            localStorage.setItem(
              "accuserweb",
              JSON.stringify(response.data.accuserweb)
            );
            localStorage.setItem(
              "accuserapp",
              JSON.stringify(response.data.accuserapp)
            );
            localStorage.setItem(
              "accestorg",
              JSON.stringify(response.data.accestorg)
            );

            localStorage.setItem(
              "accconfigrentas",
              JSON.stringify(response.data.accconfigrentas)
            );
            localStorage.setItem(
              "accrentasinm",
              JSON.stringify(response.data.accrentasinm)
            );
            localStorage.setItem(
              "accpdfrentas",
              JSON.stringify(response.data.accpdfrentas)
            );
            localStorage.setItem(
              "accopinm",
              JSON.stringify(response.data.accopinm)
            );
            localStorage.setItem(
              "accoprentas",
              JSON.stringify(response.data.accoprentas)
            );

            localStorage.setItem(
              "accconfigestadal",
              JSON.stringify(response.data.accconfigestadal)
            );
            localStorage.setItem(
              "accestadal",
              JSON.stringify(response.data.accestadal)
            );
            localStorage.setItem(
              "accpdfestadal",
              JSON.stringify(response.data.accpdfestadal)
            );
            localStorage.setItem(
              "accopestadal",
              JSON.stringify(response.data.accopestadal)
            );
            localStorage.setItem(
              "accsolvencia",
              JSON.stringify(response.data.accsolvencia)
            );
            localStorage.setItem(
              "accconfigsolvencia",
              JSON.stringify(response.data.accconfigsolvencia)
            );
            localStorage.setItem(
              "accpdfsolvencia",
              JSON.stringify(response.data.accpdfsolvencia)
            );
            localStorage.setItem(
              "accopsolvencia",
              JSON.stringify(response.data.accopsolvencia)
            );
            localStorage.setItem(
              "acctimbreelectromod",
              JSON.stringify(response.data.acctimbreelectromod)
            );
            localStorage.setItem(
              "accconfigtimbreelectro",
              JSON.stringify(response.data.accconfigtimbreelectro)
            );

            localStorage.setItem(
              "crudtimbreelectro",
              JSON.stringify(response.data.crudtimbreelectro)
            );
            localStorage.setItem(
              "crudente",
              JSON.stringify(response.data.crudente)
            );
            localStorage.setItem(
              "cruddependencia",
              JSON.stringify(response.data.cruddependencia)
            );
            localStorage.setItem(
              "crudtramite",
              JSON.stringify(response.data.crudtramite)
            );
            localStorage.setItem(
              "crudpermisotimbreelct",
              JSON.stringify(response.data.crudpermisotimbreelct)
            );

            localStorage.setItem(
              "exon1x500",
              JSON.stringify(response.data.exon1x500)
            );
            localStorage.setItem(
              "exonmina",
              JSON.stringify(response.data.exonmina)
            );
            localStorage.setItem(
              "exonproduccion",
              JSON.stringify(response.data.exonproduccion)
            );
            localStorage.setItem(
              "exonexpendedor",
              JSON.stringify(response.data.exonexpendedor)
            );
            localStorage.setItem(
              "exonente",
              JSON.stringify(response.data.exonente)
            );

            localStorage.setItem(
              "accdeudamina",
              JSON.stringify(response.data.accdeudamina)
            );

            localStorage.setItem(
              "accdeuda1x1000",
              JSON.stringify(response.data.accdeuda1x1000)
            );

            localStorage.setItem("post", JSON.stringify(response.data));

            window.location.href = "/inicio";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const mostrarClave = () => {
    if (tipoInput === "password") {
      setTipoInput("text");
      setIconEye("fas fa-eye-slash");
    } else {
      setTipoInput("password");
      setIconEye("fas fa-eye");
    }
  };

  function loginUserCallback() {
    setLoading(true);
    sinIgn();
  }

  useEffect(() => {
    cargarIpMac();
  }, []);

  return (
    <div className="contenedor">
      <section className="baner" style={{ margin: 0, pading: 0 }}>
        <img
          className="img-fluid d-none d-sm-block"
          style={{ width: "100%", height: "100%" }}
          src="imagenes/admin.jpg"
        />
        <img
          className="img-fluid d-sm-none"
          style={{ width: "100%", height: "100%" }}
          src="imagenes/admin2.jpg"
        />

        <div className="baner-content">
          <Fade top>
            <div className="nav fixed d-none d-xl-block">
              <div className="container mx-auto justify-content-between">
                <Fade left>
                  <div className="navLogo d-flex ">
                    <img
                      className="img-fluid logoSygre"
                      src="imagenes/logo3.png"
                    />
                  </div>
                  <div className="container-fluid text-center d-none d-sm-block contenedor-label">
                    <label> SISTEMA INTEGRAL PARA EL CONTROL Y</label>
                    <br />
                    <label> GESTION DE TRIBUTOS ESTADALES</label>
                  </div>
                </Fade>
              </div>
            </div>
          </Fade>
          <div className="sistema d-none d-xl-block">
            <h1>
              <span className="span1">
                <strong>S-</strong>
              </span>
              <span className="span2">TIMBRES</span>
            </h1>
          </div>
          <Zoom>
            <div className="boder text-center d-none d-sm-block col align-self-center">
              <div className="col-12 user-img">
                {/*                 <img src={op.imagenes + '/imagen?img=logo.png'} alt="" /> */}
                <img className="img-fluid" src={"imagenes/" + op.logo} />
              </div>
              <h1 className="municipio">{op.nombre}</h1>
              <div style={{ overflow: "auto", height: "50vh" }}>
                <form onSubmit={onSubmit} className="mb-5">
                  <div className="input-group mt-5">
                    <input
                      autoFocus
                      ref={txtUserName}
                      type="text"
                      autoComplete="off"
                      className="form-control input2"
                      required
                      placeholder="Usuario:"
                      name="username"
                      value={values.username}
                      onKeyPress={(event) => {
                        if (event.which === 13) {
                          txtPassword.current.focus();
                        }
                      }}
                      onChange={onChange}
                    />
                  </div>

                  <div className="input-group mt-3">
                    <input
                      ref={txtPassword}
                      type={tipoInput}
                      autoComplete="off"
                      className="form-control input2"
                      required
                      placeholder="Contraseña:"
                      name="password"
                      value={values.password}
                      onChange={onChange}
                    />
                    <button
                      type="button"
                      style={{ border: "none" }}
                      onClick={mostrarClave}
                      className="text-light rounded bg-transparent border-bottom border-light"
                    >
                      <i className={iconeye}></i>{" "}
                    </button>
                  </div>

                  <button type="submit" className="boton rounded-pill">
                    <i className="fas fa-sign-in-alt"></i> Ingresar
                  </button>
                </form>
                <a
                  href="#"
                  className="col-md-12 mx-auto mt-5 text-light"
                  onClick={abrirInformacion}
                >
                  RECUPERAR INFORMACIÓN
                </a>
              </div>
            </div>
          </Zoom>

          <div className="container boder2 text-center d-sm-none ">
            <div className="col-12 user-img2 ">
              <img className="img-fluid" src={"imagenes/" + op.logo} />
              {/* <img src={op.imagenes + '/imagen?img=logo.png'} alt="" /> */}
            </div>
            <div className=" d-block d-xl-none" style={{ marginTop: "3%" }}>
              <label> SISTEMA INTEGRAL PARA EL CONTROL Y </label>
              <label> GESTION DE TRIBUTOS ESTADALES</label>
              <h1>S-TIMBRES</h1>
            </div>
            <div
              className="container"
              style={{ overflow: "auto", height: "50vh" }}
            >
              <form onSubmit={onSubmit}>
                <div className="input-group mt-5">
                  <input
                    type="text"
                    autoComplete="off"
                    className="inpt form-control"
                    required
                    placeholder="Usuario:"
                    name="username"
                    value={values.username}
                    onChange={onChange}
                  />
                </div>
                <div className="input-group mt-5">
                  <input
                    type={tipoInput}
                    autoComplete="off"
                    className="inpt form-control"
                    required
                    placeholder="Contraseña:"
                    name="password"
                    value={values.password}
                    onChange={onChange}
                  />
                  <button
                    type="button"
                    style={{ border: "none" }}
                    onClick={mostrarClave}
                    className="text-light rounded bg-transparent border-bottom border-light"
                  >
                    <i className={iconeye}></i>{" "}
                  </button>
                </div>
                <button type="submit" className="boton rounded-pill">
                  <i className="fas fa-sign-in-alt"></i> Ingresar
                </button>
              </form>
            </div>
          </div>
        </div>
        <footer className="footer fixed-bottom text-center text-light">
          <strong>
            Copyright © 2024 <a href="#">Sygreca</a>.
          </strong>
          Todos los Derechos Reservados.
        </footer>
      </section>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <RecuperarInformacion show={mostrar} onHideCancelar={cerrarInformacion} />
      <Dimmer active={loading} />
    </div>
  );
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login.js